
  import { mapState } from 'vuex'
  import ScrouselTabs from '~/components/producet-scence/scrousel-tabs.vue'
  import CreateExamination from '~/components/producet-scence/create-examination.vue'
  import MoreShow from '~/components/producet-scence/more-show.vue'
  import CustomerCase from '~/components/producet-scence/customer-case.vue'
  import { getHomePageConfig, httpPostCnkiSign, httpPostCnkiLogin, httpPostBaiduWenkuCode } from '~/api/home/index.js'
  import { set as setCookie, del as deleteCookie } from '~/utils/cookie.js'
  import { loadJS } from '~/utils/tools'

  export default {
    name: 'SassesSurvey',
    components: {
      ScrouselTabs,
      CreateExamination,
      MoreShow,
      CustomerCase,
    },
    layout: 'scence-single',
    data() {
      return {
        ConfData: {},
        nexturl: '/create/scene/create-template/?scene=survey',
        openxSDK: null,
        cnkiOpenId: '', // 知网用户openId
        fromData: {
          cnki: '知网',
          bdxueshu: '百度学术',
        },
      }
    },
    fetchOnServer: false,
    async fetch() {
      await this.init()
    },
    head: {
      title: '问卷网-市场调研问卷-免费调查问卷制作平台',
      link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/survey/' }],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '问卷调查,调查问卷,市场调查,产品调查,学生调查,问卷网',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '问卷调查就用问卷网，满足各类调研场景：市场调查、产品调查、学生调查，提供20余万精品调查问卷模板，支持微信，微博，QQ等多种发布模式，自动生成专业的分析报表。',
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
        },
      ],
    },
    computed: {
      ...mapState(['isMobile', 'loginStatus']),
      href() {
        const path = this.nexturl
        return this.loginStatus.loggedIn == 1 ? path : ''
      },
      loginText() {
        const { from = '' } = this.$route.query
        return this.fromData[from] ? `使用${this.fromData[from]}登录` : '免费使用'
      },
      // 是否来自知网跳转
      isFromCnki() {
        const fromLink = document.referrer
        const { from = '' } = this.$route.query
        console.log('fromLink=====', fromLink)
        console.log('from=====', from)
        return fromLink.includes('cnki') || from.includes('cnki')
      },
      // 是否来自百度学术跳转
      isFromBaiduWenku() {
        const fromLink = document.referrer
        const { from = '' } = this.$route.query
        return fromLink.includes('bdxueshu') || from.includes('bdxueshu')
      },
      // 路由携带的openid
      openIdQuery() {
        const { openId = '' } = this.$route.query
        return openId
      },
    },
    mounted() {
      this.loadCnkiJs()
      this.setRegisterConfig()
      this.setloginedCookie()
    },
    methods: {
      init() {
        return getHomePageConfig().then(({ data }) => {
          this.ConfData = {
            userNum: data?.total_member_count / 10000,
            dataNum: data?.total_rspd_count / 100000000,
          }
        })
      },
      /**
       * 修改登入界面的配置
       */
      setRegisterConfig() {
        // 配置登入页面
        this.$store.commit('setLoginStatus', {
          nexturl: this.nexturl,
        })
      },
      handLogin() {
        if (this.isFromCnki) {
          // 知网登录-sdk鉴权
          this.cnkiSignLogin()
          return
        }

        if (this.isFromBaiduWenku) {
          // 百度学术登录-sdk鉴权
          this.baiduWenkuSignLogin()
          return
        }

        // 问卷网登录
        this.wenjuanLogin()
      },
      // 埋点设置
      setloginedCookie() {
        const {
          $route: {
            query: { utm_source },
          },
        } = this
        if (utm_source) {
          setCookie('utm_source', utm_source)
        } else if (this.isFromCnki) {
          // 知网跳转，埋点cnki
          setCookie('utm_source', 'cnki')
        } else if (this.isFromBaiduWenku) {
          // 百度学术跳转，埋点bdxueshu
          setCookie('utm_source', 'bdxueshu')
        }
      },

      // 问卷网登录
      wenjuanLogin() {
        if (!this.loggedIn) {
          if (!this.isMobile)
            return this.$store.commit('setLoginStatus', {
              show: true,
            })
          this.$href('/m/login/?quicklogin=1&emailorusername=&vvv=16728549930973728')
        }
      },

      // 引入知网JS-SDK
      loadCnkiJs() {
        loadJS('https://openx.cnki.net/sdk/openx-jssdk-2.0.0.js', () => {
          console.log('知网sdk接入成功')
        })
      },
      // 百度学术登录-sdk鉴权
      async baiduWenkuSignLogin() {
        try {
          const res = await httpPostBaiduWenkuCode()

          if (res.status == 200 && res.status_code == 1) {
            const {
              authorize_url: authorizeUrl,
              client_id: clientId,
              redirect_uri: redirectUri,
              response_type: responseType,
              scope,
              state,
            } = res.data
            window.location.href = `${authorizeUrl}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`
          }
        } catch (error) {
          console.log('百度学术登录失败', error)
        }
      },
      // 知网登录
      async cnkiSignLogin() {
        try {
          const params = {
            url: window.location.href,
          }
          // 内部获取配置参数
          const res = await httpPostCnkiSign(params)
          if (res.status == 200 && res.status_code == 1) {
            const { app_id: appid, noncestr, signature, timestamp } = res.data
            // 注入权限验证配置
            this.openxSDK = openx.config({
              appid, // 开放平台申请的 appid
              timestamp, // 必填，生成签名的时间戳
              noncestr, // 必填，生成签名的随机串
              signature, // 必填，签名
            })
            // 通过 ready 接口处理成功验证
            await this.openxSDK.ready()
            console.log('权限配置成功，SDK 已准备就绪')
            if (this.openIdQuery) {
              // 路由中携带知网openId,直接调用
              this.cnkiOpenId = this.openIdQuery
            } else {
              // 发起用户授权登录弹窗-获取openId
              const cnKiRes = await this.openxSDK.login()
              const { openId } = cnKiRes
              this.cnkiOpenId = openId
            }
            // 内部登录接口
            const loginRes = await httpPostCnkiLogin({ openid: this.cnkiOpenId })
            if (loginRes.status == 200 && loginRes.status_code == 1) {
              this.$message2.success('登录成功')
              // 跳转列表页
              window.location.href = '/list/'
            } else {
              console.log('登录失败：', loginRes)
              this.$message2.error('登录失败')
            }
          } else {
            console.log('签名验证失败：', res)
            this.$message2.error('签名验证失败')
          }
        } catch (error) {
          console.log('知网登录失败', error)
        }
      },
    },
  }
